import {
  Button,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Td,
  Tooltip,
  useToast,
  Tr,
  Checkbox,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
  Flex,
  Icon,
  Box,
  useDisclosure,
  IconButton,
  Table,
  Tbody,
} from "@chakra-ui/react";

import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import CrmDataService from "../../services/data";
import { GoUnlink } from "react-icons/go";
import { RiCustomerService2Fill } from "react-icons/ri";
import { BsInfoCircleFill } from "react-icons/bs";
import { CloseIcon } from "@chakra-ui/icons";
import { PiNoteBold } from "react-icons/pi";
import { NoteModal } from "../Modals/NoteModal";
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { CgNotes } from "react-icons/cg";
import { TbNotes } from "react-icons/tb";
import { TreatmentPlanModal } from "../Modals/TreatmentPlanModal";
import { SessionPlanModal } from "../Modals/SessionPlanModal";

const experts = [
  { label: "User1", value: "tamannarajpal" },
  { label: "User2", value: "mahi" },
  { label: "User3", value: "divanshi" },
];

const getExpertLabel = (value: string | undefined) => {
  const match = experts.find((e) => e.value === value);
  return match?.label || value;
};

export const CustomerTableRow = ({
  el,
  setAction,
  setName,
  setPhoneNumber,
  selectedUser,
  setSelectedUser,
  selectedUserId,
  setSelectedUserId,
  setUserId,
  setAppUserId,
  setEmailVariables,
  page,
  pageId,
  appliedFilters,
  searchQuery,
  func,
  setFollowupLogData,
  setIsWhatsappUnavailable,
}: any) => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const {
    _id,
    user_information: { email, app_user_id, gender, age },
    bookingDetails,
    user_treatment_plans,
    user_session_plans,
    status,
    channel_unsubscribed,
    tag,
    assigned_expert,
    expert,
    tracking_sources,
    whatsapp_unavailable,
    owner_note,
    note,
    last_followup,
  } = el;

  const [phone, setPhone] = useState("");

  const [channels, setChannels] = useState(channel_unsubscribed || {});

  const [enabledEmail, setEnabledEmail] = useState(null);

  const [tagValue, setTagValue] = useState(tag);

  const [waCheckBox, setWaCheckbox] = useState(whatsapp_unavailable);

  const [expertId, setExpertId] = useState("");

  const [modal, setModal] = useState("");

  const followupDateTime = last_followup
    ? DateTime.fromISO(last_followup).setZone("local")
    : null;
  const followupDate = followupDateTime?.toFormat("yyyy-MM-dd") || "";
  const followupTime = followupDateTime?.toFormat("hh:mm a") || "";

  const updateChannels = (channels: any) => {
    CrmDataService.updateChannels(_id, channels).catch((error: any) => {
      console.log(error);
    });
  };

  const handleChannels = (channel: any) => {
    setChannels((prev: any) => {
      const updated = {
        ...prev,
        [channel]: !prev[channel],
      };
      updateChannels(updated);
      return updated;
    });
  };

  const handleTag = (tagValue: any) => {
    const data = { tag: tagValue };

    CrmDataService.updateCrmDataById(_id, data)
      .then(() => {
        setTagValue(tagValue);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const renderIcon = () => {
    switch (tagValue) {
      case "followup":
        return <FaCheck size={15} color="green" />;
      case "unfollow":
        return <IoClose size={20} color="maroon" />;
      default:
        return undefined;
    }
  };

  const handleNotOnWhatsapp = (e: any) => {
    const checked = e.target.checked;
    setWaCheckbox(checked);
    const waValue = checked ? true : false;

    const data = { whatsapp_unavailable: waValue };

    CrmDataService.updateCrmDataById(_id, data)
      .then((res) => {
        setIsWhatsappUnavailable(waValue);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const expertNames: any = bookingDetails
    ? bookingDetails?.map((item: any) => item.expert_name)
    : [];

  const expertIds: any = bookingDetails
    ? bookingDetails?.map((item: any) => item.expert_id)
    : [];

  const totalSessionCounts: any = bookingDetails
    ? bookingDetails?.map((item: any) => item.total_sessions)
    : [];
  const sessionsLeft: any = bookingDetails
    ? bookingDetails?.map((item: any) => item.upcoming_sessions.length)
    : [];

  const lastSessionDates = bookingDetails
    ? bookingDetails.map((item: any) => {
        const date = item.latest_session_date;
        if (!date) return "";

        const parsedDate = DateTime.fromISO(date, { setZone: true });
        return parsedDate.isValid ? parsedDate.toFormat("yyyy-MM-dd") : "";
      })
    : [];

  const lastPurchaseDates = bookingDetails
    ? bookingDetails?.map((item: any) => {
        const date = item?.latest_booking_date;
        if (!date) return "";
        const [month, day, year] = date.split("/");
        if (!month || !day || !year) return "";
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      })
    : [];

  const [data, setData] = useState({
    name: "",
    gender: "",
    age: "",
    issues: [],
    expert: [],
    total_session_count: [],
    sessions_left: [],
    last_session_date: [],
    last_purchase_date: [],
  });

  const getUserDetails = (email: any) => {
    CrmDataService.getcustomerdetails(email, app_user_id, status)
      .then((res) => {
        const {
          bookingDetails,
          result: {
            personal_information: { full_name, gender, age, phone_number },
          },
        }: any = res.data;

        const expertNames = bookingDetails
          ? bookingDetails.map((item: any) => item.expert_name)
          : [];
        const totalSessionCounts = bookingDetails
          ? bookingDetails.map((item: any) => item.total_sessions)
          : [];
        const sessionsLeft = bookingDetails
          ? bookingDetails.map((item: any) => item.upcoming_sessions.length)
          : [];
        const lastSessionDates = bookingDetails
          ? bookingDetails.map((item: any) => item.latest_session_date)
          : [];
        const lastPurchaseDates = bookingDetails
          ? bookingDetails.map((item: any) => item.latest_booking_date)
          : [];

        setData({
          ...data,
          name: full_name,
          gender,
          age,
          expert: expertNames,
          total_session_count: totalSessionCounts,
          sessions_left: sessionsLeft,
          last_session_date: lastSessionDates,
          last_purchase_date: lastPurchaseDates,
        });

        setName(full_name);
        setPhoneNumber(phone_number);
        setFollowupLogData({
          email,
          original_status: tracking_sources?.[0]?.status,
          current_status: status,
        });
        setPhone(phone_number);
        setAppUserId(app_user_id);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const maskEmail = (email: string) => {
    if (!email || !email.includes("@")) return "No email provided";
    const [localPart, domain] = email.split("@");

    const visibleLength = Math.max(0, localPart.length - 4);
    const visiblePart = localPart.slice(0, visibleLength);
    const maskedPart = "*".repeat(Math.min(4, localPart.length));

    return `${visiblePart}${maskedPart}@${domain}`;
  };

  // console.log(enabledEmail, "email");

  const isDisabled = (type: any) => {
    const isMissing =
      type === "phone" ? !phone : type === "email" ? !email : !app_user_id;

    const isUnsubscribed =
      type === "phone"
        ? channels?.whatsapp
        : type === "email"
        ? channels?.email
        : channels?.app;

    return isMissing || isUnsubscribed;
  };

  useEffect(() => {
    setEmailVariables(data);
  }, [data]);

  useEffect(() => {
    setData({
      name: "",
      gender: "",
      age: "",
      issues: [],
      expert: [],
      total_session_count: [],
      sessions_left: [],
      last_session_date: [],
      last_purchase_date: [],
    });

    setEnabledEmail(null);
    setSelectedUser(null);
  }, [page, pageId, appliedFilters, searchQuery]);

  useEffect(() => {
    if (channel_unsubscribed) {
      setChannels(channel_unsubscribed);
    }
  }, [channel_unsubscribed]);

  useEffect(() => {
    setTagValue(tag);
  }, [tag, page, pageId]);

  return (
    <Tr
      bg={selectedUser === email ? "gray.200" : "white"}
      onClick={() => {
        getUserDetails(email);
        setEnabledEmail(email);
        setSelectedUser(email);
        setSelectedUserId(_id);
      }}
    >
      <Td
        // bg="red"
        px={1}
        style={{
          width: "300px",
          minWidth: "300px",
          maxWidth: "300px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        borderBottom="1px solid gray"
        cursor="pointer"
      >
        {/* {part_of_last_sync && (
          <Text as="sub" color="violet" fontSize="xs" fontWeight="bold">
            (new)&nbsp;
          </Text>
        )} */}
        {/* {maskEmail(email)} */}
        <Flex align="center" gap="1">
          {email}
          <Tooltip
            label={<Text whiteSpace="normal">{note || "no remarks"}</Text>}
            placement="top"
          >
            <Box
              as="span"
              onClick={() => {
                // if (!selectedUserId) return; // simulate disabled
                setModal("notemodal");
                onOpen();
              }}
              // cursor={selectedUserId ? "pointer" : "not-allowed"}
              // opacity={selectedUserId ? 1 : 0.4}
              _hover={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              _focus={{ boxShadow: "none" }}
              transition="all 0.2s"
              p={1}
              borderRadius="md"
            >
              <PiNoteBold size={14} color="#fdb508" />
            </Box>
          </Tooltip>
        </Flex>
      </Td>
      {modal === "notemodal" && (
        <NoteModal
          key={selectedUserId}
          isOpen={isOpen}
          onClose={onClose}
          id={selectedUserId}
          func={func}
          existingNote={note}
        />
      )}
      {accessControls.includes("salesAdmin") && (
        <Td
          px={1}
          borderBottom="1px solid gray"
          style={{
            width: "150px", // or any fixed width you prefer
            minWidth: "150px",
            maxWidth: "150px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Flex align="center" gap="1">
            <Tooltip
              label={
                <Text whiteSpace="normal">{owner_note || "no remarks"}</Text>
              }
              placement="top"
            >
              <span>
                <BsInfoCircleFill size={14} color="#fdb508" />
              </span>
            </Tooltip>
            {getExpertLabel(
              (assigned_expert === "expert4_tamannarajpal" && expert
                ? expert
                : assigned_expert || expert
              )?.split("_")[1] || "tamannarajpal"
            )}
          </Flex>
        </Td>
      )}
      {/* <Td>{data.name}</Td> */}
      <Td px={1} borderBottom="1px solid gray">
        {gender}
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        {age}
      </Td>
      {/* <Td
        px={1}
        borderBottom="1px solid gray"
        style={{
          width: "200px",
          minWidth: "200px",
          maxWidth: "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <Tooltip
          label={<Text whiteSpace="normal">{data.issues.join(", ")}</Text>}
          hasArrow
          placement="top"
          maxW="300px"
          isTruncated
        >
          <Text isTruncated>{data.issues.join(", ")}</Text>
        </Tooltip>
      </Td> */}
      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {expertNames.map((e: any, index: any) => (
              <Tr key={index}>
                <Td py={2} px={0}>
                  {e}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {expertIds.map((e: any, index: any) => {
              const plan = user_treatment_plans?.find(
                (p: any) => p.expert_id === e
              );

              let hasValidPlan = false;
              if (
                plan?.treatment_plans &&
                Array.isArray(plan.treatment_plans)
              ) {
                const answeredCount = plan.treatment_plans?.[
                  plan?.treatment_plans?.length - 1
                ].plan?.filter(
                  (qa: any) => qa.values && qa.values.trim() !== ""
                ).length;

                hasValidPlan = answeredCount >= 4;
              }

              return (
                <Tr>
                  <Td
                    py={4}
                    key={index}
                    onClick={() => {
                      if (hasValidPlan) {
                        setExpertId(e);
                        setModal("treatmentplanmodal");
                        onOpen();
                      }
                    }}
                  >
                    {/* {e} */}
                    {hasValidPlan && <CgNotes size={14} color="#fdb508" />}
                    {/* <CgNotes size={14} color="#fdb508" /> */}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
          {modal === "treatmentplanmodal" && (
            <TreatmentPlanModal
              key={expertId}
              isOpen={isOpen}
              onClose={onClose}
              user={selectedUser}
              expert={expertId}
            />
          )}
        </Table>
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {expertIds.map((e: any, index: any) => {
              const plan = user_session_plans?.find(
                (p: any) => p.expert_id === e
              );

              let hasValidPlan = false;

              if (plan?.session_plans && Array.isArray(plan.session_plans)) {
                const latestPlan = plan?.session_plans?.at(-1);
                hasValidPlan = !!latestPlan?.session_id?.trim() && !!latestPlan?.session_summary?.trim() && !!latestPlan?.next_session_goal?.trim();
              }

              return (
                <Tr>
                  <Td
                    py={4}
                    key={index}
                    onClick={() => {
                      if (hasValidPlan) {
                        setExpertId(e);
                        setModal("sessionplanmodal");
                        onOpen();
                      }
                    }}
                  >
                    {hasValidPlan && <CgNotes size={14} color="#fdb508" />}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
          {modal === "sessionplanmodal" && (
            <SessionPlanModal
              key={expertId}
              isOpen={isOpen}
              onClose={onClose}
              expert={expertId}
              user_session_plans={user_session_plans}
            />
          )}
        </Table>
      </Td>

      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {totalSessionCounts.map((e: any, index: any) => (
              <Tr key={index}>
                <Td py={4}>{e}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {sessionsLeft.map((e: any, index: any) => (
              <Tr key={index}>
                <Td py={4}>{e}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {lastSessionDates.map((e: any, index: any) => (
              <Tr key={index}>
                <Td py={4}>{e}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        <Table variant="unstyled" size="sm">
          <Tbody>
            {lastPurchaseDates.map((e: any, index: any) => (
              <Tr key={index}>
                <Td py={4}>{e}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Td>

      <Td px={1} borderBottom="1px solid gray">
        {followupDate} {followupTime}
      </Td>
      <Td
        px={2}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Checkbox
          colorScheme="red"
          icon={<Icon as={CloseIcon} />}
          isChecked={waCheckBox}
          onChange={handleNotOnWhatsapp}
        ></Checkbox>
      </Td>

      <Td
        px={2}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={renderIcon()}
            size="xs"
            variant="outline"
            borderColor="gray.100"
          />
          <MenuList>
            <MenuItem onClick={() => handleTag("")}>Unmark</MenuItem>
            <MenuItem onClick={() => handleTag("followup")}>
              Mark for Followup
            </MenuItem>
            <MenuItem onClick={() => handleTag("unfollow")}>
              Mark for Unfollow
            </MenuItem>
          </MenuList>
        </Menu>
      </Td>

      <Td
        px={1}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Menu>
          <MenuButton
            as={Button}
            size="xs"
            bg="white"
            border="1px solid gray"
            disabled={enabledEmail !== email}
          >
            <RiCustomerService2Fill />
          </MenuButton>
          <MenuList minWidth="unset">
            <Tooltip
              label="no phone provided"
              isDisabled={!isDisabled("phone")}
              placement="right"
              hasArrow
            >
              <span>
                <MenuItem
                  isDisabled={isDisabled("phone")}
                  onClick={() => setAction("call")}
                  _hover={{ bg: "#fdb508", color: "black" }}
                  _focus={{ bg: "#fdb508" }}
                  value="call"
                >
                  Call/Chat
                </MenuItem>
              </span>
            </Tooltip>
            {accessControls.includes("admin") && (
              <Tooltip
                label="no phone provided"
                isDisabled={!isDisabled("phone")}
                placement="right"
                hasArrow
              >
                <span>
                  <MenuItem
                    isDisabled={isDisabled("phone")}
                    onClick={() => {
                      setAction("whatsapp");
                      setUserId(phone);
                    }}
                    _hover={{ bg: "#fdb508", color: "black" }}
                    _focus={{ bg: "#fdb508" }}
                    value="whatsapp"
                  >
                    WhatsApp Template
                  </MenuItem>
                </span>
              </Tooltip>
            )}
            <Tooltip
              label="no app userid provided"
              isDisabled={!isDisabled("app")}
              placement="right"
              hasArrow
            >
              <span>
                <MenuItem
                  isDisabled={isDisabled("app")}
                  onClick={() => {
                    setAction("notification");
                    setUserId(app_user_id);
                  }}
                  _hover={{ bg: "#fdb508", color: "black" }}
                  _focus={{ bg: "#fdb508" }}
                  value="notification"
                >
                  App Notification
                </MenuItem>
              </span>
            </Tooltip>
            <Tooltip
              label="no email provided"
              isDisabled={!isDisabled("email")}
              placement="right"
              hasArrow
            >
              <span>
                <MenuItem
                  isDisabled={isDisabled("email")}
                  onClick={() => {
                    setAction("email");
                    setUserId(email);
                  }}
                  _hover={{ bg: "#fdb508", color: "black" }}
                  _focus={{ bg: "#fdb508" }}
                  value="email"
                >
                  Email
                </MenuItem>
              </span>
            </Tooltip>
          </MenuList>
        </Menu>
      </Td>

      <Td
        px={1}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Popover placement="bottom-start" closeOnBlur={true}>
          <PopoverTrigger>
            <Button bg="white" border="1px solid gray" size="xs">
              <GoUnlink />
            </Button>
          </PopoverTrigger>
          <PopoverContent w="150px" p={2}>
            <PopoverBody>
              <VStack align="start" spacing={2}>
                <Checkbox
                  isChecked={channels.whatsapp}
                  onChange={() => handleChannels("whatsapp")}
                >
                  WhatsApp
                </Checkbox>
                <Checkbox
                  isChecked={channels.app}
                  onChange={() => handleChannels("app")}
                >
                  App
                </Checkbox>
                <Checkbox
                  isChecked={channels.email}
                  onChange={() => handleChannels("email")}
                >
                  Email
                </Checkbox>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Td>
    </Tr>
  );
};
